import {
  ExplorerErrorPage,
  ExplorerIndexPage,
} from '@squareup/dex-feature-dex-tech-main-explorer-page';
import { useGraph } from '@squareup/dex-feature-hooks-graph';
import { useSelectErrorState } from '@squareup/dex-store-access-shared-main-selectors';
import { Head } from '@squareup/dex-ui';
import {
  getNextPublicApiExplorerNameOrDefault,
  getNextPublicSquareDocsURL,
} from '@squareup/dex-utils-environment';
import { getStateNodeErrorStatusAndMessage } from '@squareup/dex-utils-error';
import { useParams } from '@squareup/dex-utils-shared-routing-hooks';
import React from 'react';

import ExplorerBasePage from '../../../shared/ExplorerBasePage';
import { explorerGetInitialProps } from '../../../shared/explorer-get-initial-props';

const PageContent = () => {
  const { graph } = useGraph();
  const query = useParams();
  const square_version = query?.square_version as string;

  const errorState = useSelectErrorState();
  const errorStatusAndMessage = getStateNodeErrorStatusAndMessage(
    errorState.global || errorState.page
  );

  const head = (
    <Head
      description="Try out Square’s API Explorer"
      canonicalPath={`/explorer/${square_version}`}
      preconnectUrl={getNextPublicSquareDocsURL()}
      title={getNextPublicApiExplorerNameOrDefault()}
    />
  );

  if (errorStatusAndMessage) {
    return (
      <>
        {head}
        <ExplorerErrorPage graph={graph} error={errorStatusAndMessage} />
      </>
    );
  } else if (!graph) {
    return null;
  } else {
    return (
      <>
        {head}
        <ExplorerIndexPage graph={graph} />
      </>
    );
  }
};

const Page = () => {
  return (
    <ExplorerBasePage>
      <PageContent />
    </ExplorerBasePage>
  );
};

Page.getInitialProps = explorerGetInitialProps;

export default Page;
